import React from 'react';
import type { WizardStepProps } from '../types';
import { FreeTextStep } from './FreeTextStep';

export const StepMade = (props: WizardStepProps) => <FreeTextStep copyKey="unusual_way_wizard.made" {...props} />;
